//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import globalMixin from "@/lib/global";
import vuexMixin from "@/lib/vuexMixin";
export default {
  mixins: [globalMixin, vuexMixin],
  data() {
    return {
      conterUnreadingNotifictionsData: 0,
      preview: false,
      rounded: true,
      expand: false,
      disabled: false,
      selectedItem: 0,
      listIdsUnread: [],
      list: [],
    };
  },
  created() {
    this.init();
  },
  computed: {
    conterUnreadingNotifictions() {
      return this.conterUnreadingNotifictionsData;
    },
  },
  watch: {
    isSolicitation(newVlue, oldValue) {
      if (newVlue !== oldValue) {
        this.getNotifications();
      }
    },
  },
  methods: {
    init() {
      this.getNotifications();
    },
    async getNotifications() {
      if (this.getToken) {
        try {
          let newList = [];
          this.listIdsUnread = [];
          let listUnread = [];
          let listread = [];
          let { data } = await this.requestEds("GET", "notifications");
          newList = data || [];
          this.conterUnreadingNotifictionsData = 0;
          for (let index = 0; index < newList.length; index++) {
            if (!newList[index].read) {
              this.conterUnreadingNotifictionsData++;
              this.listIdsUnread.push(newList[index].id);

              listUnread.push(newList[index]);
            } else {
              listread.push(newList[index]);
            }
          }

          this.list = listUnread.concat(listread);
        } catch (error) {
          return error;
        }
      }
    },
    async updateNotifications() {
      try {
        const arrayNormalizado = [];
        this.listIdsUnread.forEach((id) => {
          arrayNormalizado.push({ ids: id });
        });
        this.requestEds("PUT", "notifications", arrayNormalizado);
        this.listIdsUnread = [];
        this.getNotifications();
      } catch (error) {
        return error;
      }
    },
  },
};
